// extracted by mini-css-extract-plugin
export default {"error_message_text":"errorMessage_error_message_text__3cSeI"};